import useApi, { ApiOptions } from '../base/useApi';
import ScanViewDTO from '@src/adapters/dto/scan/ScanViewDTO';

interface Params {
  id: string;
}

interface Result {
  scan: ScanViewDTO;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/scan',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindScanLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindScanLazy;
